import { render } from "./LiveLinkAccessTables.vue?vue&type=template&id=59e12659"
import script from "./LiveLinkAccessTables.vue?vue&type=script&lang=js"
export * from "./LiveLinkAccessTables.vue?vue&type=script&lang=js"

import "./LiveLinkAccessTables.vue?vue&type=style&index=0&id=59e12659&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__